import i18n from 'modules/core/lib/i18n'

import { Type } from './types'

export const translations = ({
  type,
  employeeName,
  date,
}: {
  type: Type
  employeeName: string | React.ReactNode
  date: string | React.ReactNode
}) => {
  const extra = { employeeName, date }

  switch (type) {
    case 'leavers':
      return i18n.tView(
        'finance.financial_workspace.employee_costs.workforce.types_details.leavers',
        {
          ...extra,
        }
      )
    case 'hires':
      return i18n.tView(
        'finance.financial_workspace.employee_costs.workforce.types_details.hires',
        {
          ...extra,
        }
      )
    case 'promotions':
      return i18n.tView(
        'finance.financial_workspace.employee_costs.workforce.types_details.promotions',
        {
          ...extra,
        }
      )
    default:
      return ''
  }
}
